import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from '@reduxjs/toolkit'

export const TenantSlice =  createSlice({
    name:"Tenant",
    initialState:{
        id: 0
    },
    reducers:{
        SetTenant(state, action: PayloadAction<number>){
            state.id = action.payload
        }
    }
});

export const { SetTenant } = TenantSlice.actions
export default TenantSlice.reducer